// extracted by mini-css-extract-plugin
export default {"page":"SettingsPage_page__ileuu","layout":"SettingsPage_layout__hW8-b","content":"SettingsPage_content__TR6yN","contentInner":"SettingsPage_contentInner__zSLRl"};